export default "__VITE_ASSET__CGYDLqrB__"